<div class="bg_login d-flex">
  <div class="w-50 h-100 login_div">
    <div class="login_form">
      <h3 class="sign_in d-flex justify-content-between mb-3">{{'INFO.FORGOT_PASSWORD_QUESTION' | translate}} <app-change-language [ShowFullName]="false"></app-change-language> </h3>
      <p>{{'INFO.FORGOT_PASSWORD_MESSAGE' | translate}}</p>
      <div class="login_field">
        <label class="lbl_pos_field">{{'LOGIN.EMAIL'|translate}}
          <i *ngIf="errorModel!=null && errorModel['Email']!=null"
             class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
             pTooltip="{{errorModel['Email']|translate}}" tooltipPosition="top"></i>
          <i *ngIf="email.touched && email.errors?.email"
             class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
             pTooltip="{{'Invalid Email format!'|translate}}" tooltipPosition="top"></i>
        </label>
        <input type="email" class="input_pos_field" [(ngModel)]="forgotPasswordModel.email" #email=ngModel required email>
        <button class="btn_login mt-3"
                [disabled]="(errorModel!=null && errorModel['Email']!=null) || email.errors || spinner"
                (click)="sendForgotPasswordRequest(forgotPasswordModel)">{{'INFO.SEND_MAIL'|translate}}</button>
        <a type="button" routerLink="/login" class="signup_link text-center mt-2">{{'INFO.SIGN_IN' | translate }}</a>
        <div class="small_spinner_wrapper" *ngIf="spinner">
          <p-progressSpinner class="w-100 text-center pos_spinner_small"></p-progressSpinner>
        </div>

      </div>
    </div>
  </div>
  <div class="w-50 h-100 logo_div">
    <div class="logo me-2"></div>
  </div>
</div>
